import { getBucketData } from 'lib/utilityFunctions';
import gameIds from '../data/GameIds';
import { persistStateTypes } from '../../reducers/persistStateReducer';

const initialState = {
  version: 1,
  overlayVisible: true,
  lasperHouseLocationIntroPlayed: false,
};

const mapReducer = (state = initialState, action) => {
  if (action.gameId !== gameIds.METAGAME) {
    return state;
  }
  switch (action.type) {
    case 'HIDE_OVERLAY':
      return {
        ...state,
        overlayVisible: false,
      };
    case 'LASPER_HOUSE_INTRO_PLAYED':
      return {
        ...state,
        lasperHouseLocationIntroPlayed: true,
      };
    case persistStateTypes.REQUESTRESPONSE_GAMESTATE_ALL: {
      const metagameBucketData = getBucketData(
        action.stateData[gameIds.METAGAME],
      ).gameDetails;
      let { lasperHouseLocationIntroPlayed } = state;
      if (metagameBucketData && metagameBucketData.lasperHouseLocationIntroPlayed) {
        lasperHouseLocationIntroPlayed = metagameBucketData.lasperHouseLocationIntroPlayed;
      }
      return {
        ...state,
        lasperHouseLocationIntroPlayed,
      };
    }
    default:
      return state;
  }
};

export default mapReducer;
